import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import ProductsPage from '../pages/products/page';
import ProductDetailPage from '../pages/product-detail/page';
import CollectionsPage from '../pages/collections/page';
import AboutPage from '../pages/about/page';
import ContactPage from '../pages/contact/page';
import CartPage from '../pages/cart/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/products/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/collections',
    element: <CollectionsPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/cart',
    element: <CartPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
